import {PropertiesPane} from '../components/NodePropertiesPane.jsx'
import ButtonGenerateBd from '../FA/PropertiesPaneButtonGenerateBd.jsx'
import ButtonGenerateCc from '../BD/PropertiesPaneButtonGenerateCc.jsx'
import ButtonGenerateRam from './PropertiesPaneButtonGenerateRam.jsx'

import {
    PropertiesPaneButtonExportReq as ButtonExportReq,
    PropertiesPaneButtonExportReq2 as ButtonExportReq2,
} from './PropertiesPaneButtonExportReq.jsx'

import {
    PropertiesPaneButtonIntegrateMap as ButtonIntegrateMap,
    PropertiesPaneButtonClearMap as ButtonClearMap,
} from './PropertiesPaneButtonIntegrateMap.jsx'

export default function PropertiesPaneBatchFm(props) {
    return (
        <PropertiesPane
            buttons={
                <>
                    <ButtonGenerateBd />
                    <ButtonGenerateRam />
                    <ButtonIntegrateMap />
                    <ButtonClearMap />
                    <ButtonExportReq />
                    <ButtonExportReq2 />
                    <ButtonGenerateCc />
                </>
            }

            {...props}
        />
    )
}
